(function(angular){
	'use strict';

	angular
		.module('portfolioAllocationChartModule')
		.factory('CapitalStackFactory', [
			'$filter',
			'Big',
			capitalStackServiceFunction
		]);

	function capitalStackServiceFunction(
		$filter,
		Big
	) {
		var factory = {
			getDebtEquityBreakdown: getDebtEquityBreakdown
		};

		return factory;

		function getParentReitBreakdown(debtEquityBreakdown, reitId) {
			return $filter('filter')(debtEquityBreakdown.debtEquityBreakdownByReit,  { reitId: parseInt(reitId) }, true)[0];
		}

		function convertToPercentages(breakdown) {
			var debtAndEquitySum = breakdown.equity.plus(breakdown.debt);
			var adjustedDebt = breakdown.debt.div(debtAndEquitySum);
			var adjustedEquity = breakdown.equity.div(debtAndEquitySum);

			breakdown.debt = adjustedDebt.toFixed(2);
			breakdown.equity = adjustedEquity.toFixed(2);

			return breakdown;
		}

		function getDebtEquityBreakdown(weightedReitElements){
			var debtEquityBreakdown = {
				debt: new Big(0),
				equity: new Big(0),
				debtEquityBreakdownByReit: []
			};
			var equityStructures = ['JV Equity', 'Equity', 'Special Purpose Entity Equity', 'Fundrise Wholly Owned'];

			if(angular.isDefined(weightedReitElements)) {
				angular.forEach(weightedReitElements, function(weightedReitElement){
					var reitElement = weightedReitElement.reitElement ? weightedReitElement.reitElement : weightedReitElement;
					var weightedAllocation = new Big(weightedReitElement.weightedAllocation);

					if(weightedAllocation > 0) {
						angular.forEach(reitElement.reits, function(reit) {
							var parentReitBreakdown = getParentReitBreakdown(debtEquityBreakdown, reit.id);

							if(angular.isUndefined(parentReitBreakdown)) {
								parentReitBreakdown = {
									reitId: parseInt(reit.id),
									debt: new Big(0),
									equity: new Big(0)
								};
								debtEquityBreakdown.debtEquityBreakdownByReit.push(parentReitBreakdown);
							}

							if (equityStructures.indexOf(reitElement.structure) !== -1) {
								debtEquityBreakdown.equity = debtEquityBreakdown.equity.plus(weightedAllocation);
								parentReitBreakdown.equity = parentReitBreakdown.equity.plus(weightedAllocation);
							} else {
								debtEquityBreakdown.debt = debtEquityBreakdown.debt.plus(weightedAllocation);
								parentReitBreakdown.debt = parentReitBreakdown.debt.plus(weightedAllocation);
							}
						});
					}
				});

				angular.forEach(debtEquityBreakdown.debtEquityBreakdownByReit, function(breakdown) {
					breakdown = convertToPercentages(breakdown);
				});

				if(debtEquityBreakdown.debt > 0 || debtEquityBreakdown.equity > 0) {
					debtEquityBreakdown = convertToPercentages(debtEquityBreakdown);
				} else {
					debtEquityBreakdown.debt = undefined;
					debtEquityBreakdown.equity = undefined;
				}
			}

			return debtEquityBreakdown;
		}
	}
})(window.angular);